import React from 'react';
import Chart from 'react-apexcharts';
import { DashboardCard } from './DashboardCard';
import { StatusAnalysis } from '../../types/checkin';

import { BoxProps } from '@mui/material';

interface StatusChartProps extends BoxProps {
  data: StatusAnalysis[];
}

export const StuckStatus: React.FC<StatusChartProps> = ({ data, sx }) => {
  const series = data.map(item => item.count);
  const labels = data.map(item => item.status);

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: 'donut',
      toolbar: { show: false }
    },
    labels,
    legend: {
      position: 'bottom'
    },
    dataLabels: {
      enabled: true
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: { width: 320 },
        legend: { position: 'bottom' }
      }
    }]
  };

  return (
    <DashboardCard title="Status dos Check-ins" sx={sx}>
      <Chart options={options} series={series} type="donut" height={350} />
    </DashboardCard>
  );
};